// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.intrastats.new', {
        url:'/new',
        views: {
            'productView@product': {
             templateUrl: 'main/product/intrastats/intrastat/intrastat.tpl.html',
            controller: 'IntrastatController as vm'
        }},
        resolve: {
            intrastat:  function() { return {}; },
            isNewIntrastat: function() {
                return true;
            }
        }
    });

    $stateProvider.state('product.intrastats.intrastat', {
        url:'/{intrastatId}',
        views: {
            'productView@product': {
            templateUrl: 'main/product/intrastats/intrastat/intrastat.tpl.html',
            controller: 'IntrastatController as vm'
        }},
        resolve: {
            intrastat: intrastatResolver,
            isNewIntrastat: function() {
                return false;
            }
        }
    });

}

// @ngInject
function intrastatResolver($stateParams, IntrastatApiService) {
    return IntrastatApiService.getIntrastat($stateParams.intrastatId);
}

// @ngInject
function IntrastatController($state, intrastat, loadSpinnerService, IntrastatApiService, ToasterService, confirmationDialogService, $translate, isNewIntrastat) {
    var vm = this;

    var intrastatCopy = {};

    vm.intrastat = intrastat;

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveIntrastat = saveIntrastat;
    vm.deleteIntrastat = deleteIntrastat;

    vm.isNewIntrastat = isNewIntrastat;
    vm.isEditing = vm.isNewIntrastat;
    vm.isAllInformationValid =isAllInformationValid;
    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewIntrastat) {
            vm.intrastat = {};
        }
    }

    function isAllInformationValid() {
        return true;
    }

    function enableEditing() {
        intrastatCopy = angular.copy(vm.intrastat);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.intrastat = intrastatCopy;
        vm.isEditing = false;
    }

    function saveIntrastat() {
        loadSpinnerService.start('mainSpinner');
        IntrastatApiService.saveIntrastat(vm.intrastat).then(function(response) {
            vm.intrastat = response;
            prepareData();
            vm.isNewIntrastat = false;
            vm.isEditing = false;
            $state.go('product.intrastats.intrastat', {intrastatId: vm.intrastat.id});
        }, function(error) {
            console.log(error);
            if (error.status !== 403) {
                ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
            }
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteIntrastat() {
        confirmationDialogService
            .showDialog($translate.instant('intrastat.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    IntrastatApiService.deleteIntrastat(vm.intrastat.id).then(function(response) {
                        vm.intrastat = response;
                        prepareData();
                        vm.isNewIntrastat = false;
                        vm.isEditing = false;
                        $state.go('product.intrastats');
                    }, function(error) {
                        console.log(error);
                        if (error.status !== 403) {
                            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                        }
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(intrastat) {
        intrastat.showEditForm = !intrastat.showEditForm;
    }

    function prepareData() {
        if (vm.intrastat === undefined) {
            return;
        }

        vm.intrastatCopy = angular.copy(vm.intrastat);
    }


}

angular
    .module('intrastats.intrastat', [])
    .config(stateConfig)
    .controller('IntrastatController', IntrastatController);
